import { AssignmentIcon } from "../components/assets/icons";
import Config from "./config";

import HttpBrowserRequest from "./http_request";

/////////////////////////// Public Functions START /////////////////////////////
const Core = {
  // Api for signup as Brand
  brandSignup: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        progress_cb(false); // Screen progress set to false
        if (!response.success) {
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_BRAND_SIGNUP),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Login as Brand
  brandLogin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_BRAND_LOGIN),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for signup as User
  userSignup: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_CREATE_USER),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for getting logged user data
  adminSelfData: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function

        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_SELF_DATA),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Create Campaign
  createCampaignUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CREATE_CAMPAIGN_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Get Brand Report
  getBrandReports: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_BRAND_REPORT),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Create Campaign
  getCampaignListAdmin: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_LIST_USER
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Create Campaign
  getCampaignUserData: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_USER
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Get Brand Data
  getBrandData: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_BRAND),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Create Brand
  createBrand: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_CREATE_BRAND),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Generate brand image url as User
  generateUploadBrandImageUrl: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    authToken,
    file
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response, file);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GENEREATE_UPLOAD_URL
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Update brand logo as User
  updateBrandLogo: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UPDATE_BRAND_LOGO
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Create Brand
  adminLogout: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },

      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_LOGOUT),
      Config.POST_METHOD,
      params,
      "application/json",

      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_USER_LOGOUT_SELF),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for  Brand list
  brandList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_BRAND_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  // Api for Get Campaign Bids user
  getCampaignBidsUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_BIDS_USER
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Get order list user
  getOrderListUser: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_ORDER_LIST_USER
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // // Api for post  Approve list user
  // approveBidUser: function (succes_cb, failed_cb, progress_cb, params, auth) {
  //   // Screen progress set to true
  //   progress_cb(true);

  //   // http request
  //   HttpBrowserRequest.fetch(
  //     function (error, response) {
  //       // Callback function

  //       // Incase of error
  //       if (!response.success) {
  //         progress_cb(false); // Screen progress set to false
  //         return failed_cb(response.err_l);
  //       }
  //       progress_cb(false); // Screen progress set to false

  //       // Return sucess response
  //       return succes_cb(response);
  //     },
  //     _api_function.constructUrn(
  //       Config.API_ENDPOINTS.API_URN_POST_APPROVE_BID_USER
  //     ),
  //     Config.POST_METHOD,
  //     params,
  //     "application/json",
  //     auth
  //   );
  // },

  // Api for post  Approve list user
  postSortlistBidUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_SHORTLIST_BID_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for post  Approve list user
  postRejectBidUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_REJECT_BID_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Get Campaign Bids user
  getCategory: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_CATEGORY),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  // Api for Get Campaign Bids user
  getCampaignContent: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_CONTENT
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getCampaignUserDetail: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_USER_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getBidsInfluencer: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_BID_INFLUENCER_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  postAssignmentWithdraw: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_USER_WITHDRAW
      ),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getAssignmentUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ASSIGNMENT_USER),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getAssignmentUser: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ASSIGNMENT_USER),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getBidList: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_BID_LIST),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },
  approveBidUser: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_APPROVE_BID_USER),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },

  generateUploadSampleMediaUrl: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_UPLOAD_MEDIA_URL),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getTransactionList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_TRANSACTION_USER),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },
  getOrgDataUser: function (succes_cb, failed_cb, progress_cb, params, auth) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ORG_DATA_USER),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },

  getUserAssignmentDetail: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_USER_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },
  postUserAssignmentReviewContent: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_REVIEW_CONTENT
      ),
      Config.POST_METHOD,
      params,
      "application/json",
      auth
    );
  },
  getInfluencerDetailPublic: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    auth
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function

        // Incase of error
        if (!response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_DETAIL_PUBLIC
      ),
      Config.GET_METHOD,
      params,
      "application/json",
      auth
    );
  },
  getMembersList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_MEMBER_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postInviteMembers: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_INVITE_MEMBER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getTransactionHistoryList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_TRANSACTION_HISTORY
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getMessagesUserList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_MESSAGE_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postMessagesUserList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_SEND_MESSAGE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postDeleteMessage: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_DELETE_MESSAGE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postUpdateCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_UPDATE_CAMPAIGN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  boostCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_BOSAST_CAMPGAIGNS
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getOfflineOnlineCampaign: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_OFFLINE_ONLINE_CAMPGAIGNS
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },

  publishCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_CAMPAIGN_PUBLISH
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getCreditList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_CREDIT_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getCreditDetail: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CREDIT_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postCreditOrder: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_CREDIT_ORDER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postForgotPassword: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_FORGOT_PASSWORD
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postVerifyForgotPassword: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_VERIFY_FORGOT_PASSWORD
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  //   succes_cb,
  //   failed_cb,
  //   progress_cb,
  //   params
  // ) {
  //
  //   // Screen progress set to true
  //   progress_cb(true);
  //   // http request
  //   HttpBrowserRequest.fetch(
  //     function (error, response, status) {
  //       // Callback function
  //       progress_cb(false);
  //       if (error) {
  //         return failed_cb("Something went wrong");
  //       }
  //       if (response) {
  //         if (response.success) {
  //           return succes_cb(response);
  //         }
  //         return failed_cb(response.err_l.map((item) => item.m).join(", "));
  //       }
  //       return failed_cb("Something went wrong");
  //     },
  //     _api_function.constructUrn(
  //       Config.API_ENDPOINTS.API_URN_POST_FORGOT_PASSWORD
  //     ),
  //     Config.POST_METHOD,
  //     params,
  //     "application/json"
  //   );
  // },

  getOrgKycDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_ORG_KYC_DETAILS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  postUpdateUserOrg: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_POST_UPDATE_ORG),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postVerifyEmailOtpOrg: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_VERIFY_EMAIL
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postVerifyEmailOrg: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_REQUEST_EMAIL_VERIFICATION
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postOrgUpdateKyc: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_POST_ORG_ADD_KYC),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getGenerateUploadUrl: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params,
    authToken,
    file
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response, file);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SUBMIT_CONTENT_TO_S3
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getOrgUserDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_ORG_DETAIL),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  postCreateOrderAssignment: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CREATE_ORDER_ASSIGNMENT
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postChangePassword: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_CHANGE_PASSWORD),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postUpdateUserProfile: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_UPDATE_USER_DATA),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getAssignmentBrandDetails: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ASSIGNMENT_BRAND),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getCampaignReport: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_REPORT_CAMPAIGN
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  updateBrandSetting: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UPDATE_BRAND_SETTING
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getPayoutList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_PAYOUT_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  postRatingInfluencer: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_RATTING_INFLUENCER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getCreditsTransactionList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CREDIT_TRANSACTION
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postPublishedCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLISHED_CAMPAIGN_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postUnPublishedCampaign: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UNPUBLISHED_CAMPAIGN_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postSaveCampaignUser: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SAVE_CAMPAIGN_USER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getInfluencerPlatformInsight: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_PLATFORM_INSIGHT
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getInfluencerInviteList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INVITE_INFLUENCER_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getInfluencerList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_INFLUENCER_LIST
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  postInfluencerInvite: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_INVITE_INFLUENCER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postInfluencerInviteWithdraw: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_INFLUENCER_LIST_WITHDRAW
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postCreateWallet: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_CREATE_WALLET),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  counterProposal: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_BID_ADMIN_CREATE_COUNTER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  adminNotificationSend: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_NOTIFICATION
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  userNotificationDetail: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_NOTIFICATION_USER_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  influencerPortfolio: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_PORTFOLIO
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  AssignmentContentList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_CONTENT_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  AssignmentContentListByContent: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_CONTENT_BY_CONTENT_ID
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  campaignAnalytics: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CAMPAIGN_ANALYTICS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  campaignContentAnalytics: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CAMPAIGN_CONTENT_ANALYTICS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getCampaignAssignmentProgress: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb(error);
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_ASSIGNMENT_PROGRESS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getAssignmentInfluencerList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        if (response && !response.success) {
          progress_cb(false);
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        progress_cb(false);
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_ASSIGNMENT_INFLUENCER_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getAssignmentContentReport: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        if (response && !response.success) {
          progress_cb(false);
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        progress_cb(false);
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_ASSIGNMENT_CONTENT_REPORT
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  campaignReportStatus: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        if (response && !response.success) {
          progress_cb(false);
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        progress_cb(false);
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_REPORT_STATUS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getContentSyncedList: function (succes_cb, failed_cb, progress_cb, params) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        if (response && !response.success) {
          progress_cb(false);
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        progress_cb(false);
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CONTENT_SYNCED_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getCampaignStatistics: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_STATISTICS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  reportSectionSetting: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l || "Failed to save visibility");
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_REPORT_SECTION_SETTING
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  customizeStatistics: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CUSTOMIZE_STATISTICS
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  updateContentMetrics: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UPDATE_CONTENT_METRICS
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getCampaignReportPublic: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_REPORT_CAMPAIGN_PUBLIC
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getPublicCampaignContentsAnalytics: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLIC_CAMPAIGN_CONTENTS_ANALYTICS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getPublicAssignmentInfluencerList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLIC_ASSIGNMENT_INFLUENCER_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getPublicContentSyncedList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLIC_CONTENT_SYNCED_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getPublicListContent: function (succes_cb, failed_cb, progress_cb, params) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLIC_LIST_CONTENT
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getPublicCampaignReport: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    progress_cb(true);
    HttpBrowserRequest.fetch(
      function (error, response) {
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response?.err_l?.join?.(", ") || response?.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PUBLIC_CAMPAIGN_REPORT
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  postAddCollection: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADD_COLLECTION),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postAddInfluencerCollection: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADD_INFLUENCER_COLLECTION
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getCollectionList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_COLLECTION_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getCollectionInfluencerList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_COLLECTION_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postCollectionDelete: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_COLLECTION_DELETE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postCollectionInfluencerDelete: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_COLLECTION_DELETE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getInfluencerDiscovery: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_DISCOVERY
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getEffectiveFollowers: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PLATFORM_EFFECTIVE_FOLLOWERS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  generateShareKey: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_COLLECTION_GENERATE_SHARE_KEY
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  addPriceToCollectionInfluencer: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_COLLECTION_ADD_PRICE_INFLUENCER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  addPriceToCollectionInfluencerAdmin: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_COLLECTION_ADD_PRICE_INFLUENCER_ADMIN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getCollectionInfluencerListByShareKey: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_COLLECTION_INFLUENCER_LIST_BY_SHARE_KEY
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  updateCollectionReviewStatus: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UPDATE_COLLECTION_REVIEW_STATUS
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getInfluencerContractsListShareData: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_CONTRACTS_LIST_BY_SHARE_KEY
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  generateShareKeyCampaignContractsList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GENERATE_CONTRACTS_SHARE_LIST_KEY
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getInfluencerContractsListShareData: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_CONTRACTS_LIST_BY_SHARE_KEY
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  generateShareKeyCampaignContractsList: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GENERATE_CONTRACTS_SHARE_LIST_KEY
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  subscriptionUserDetail: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SUBSCRIPTION_USER_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  adminLogin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_LOGIN),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  adminGetDataSelf: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN__GET_DATA_SELF
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getAdminReportDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_REPORT),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  // KYC Acception or rejection Call
  postAdminVerify: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_VERIFY),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getsynPlatform: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_PLATFORM),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  payoutListAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_PAYOUT_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  assignmentAdminDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ASSIGNMENT_ADMIN_DETAILS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  campaginAdminDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_CAMPAIGN_DETAIL
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getInfluencerAdminDetail: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_ADMIN_DETAILS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  payoutAdminDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PAYOUT_ADMIN_DETAILS
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postBanUnBanInfluncer: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_INFLUENCER_BAN),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  payoutAdminInitiateTransfer: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_PAYOUT_INITIATE_TRANSFER
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  handleEditProfile: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_DETAIL_UPDATE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  handleEditBulkProfile: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_INFLUENCER_BULK_DETAIL_UPDATE
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },

  getAssignmentAdminDetails: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_CONTRACT_LIST
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getAdminNotification: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ADMIN_NOTIFICATION_SEND
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getAdminKycList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_KYC_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getAdminKycDetail: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l.map((item) => item.m).join(", "));
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_KYC_DETAIL),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },

  getOrgListAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_ORG_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getCampaignListAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_CAMPAIGN_LIST_USER
      ),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getTransListAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_TRANS_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  getBrandListAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADMIN_BRAND_LIST),
      Config.GET_METHOD,
      params,
      "application/json"
    );
  },
  postCreateWalletAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CREATE_WALLET_ADMIN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postCreateCreditAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_CREATE_CREDIT_ADMIN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postMarkComplete: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_MARK_COMPLETE),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postUnPublishedCampaign: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_UPDATE_CAMPAIGN_ADMIN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postActiveInactiveCampaign: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_ACTIVE_INACTIVE_CAMPAIGN_ADMIN
      ),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  postCancelContract: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http request
    HttpBrowserRequest.fetch(
      function (error, response, status) {
        // Callback function
        progress_cb(false);
        if (error) {
          return failed_cb("Something went wrong");
        }
        if (response) {
          if (response.success) {
            return succes_cb(response);
          }
          return failed_cb(response.err_l);
        }
        return failed_cb("Something went wrong");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_CANCEL_CONTRACT),
      Config.POST_METHOD,
      params,
      "application/json"
    );
  },
  getRemoveBankDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(false, response);
      },

      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_BANK_DETAILS
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  createAssignmentAdmin: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(false, response);
      },

      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_ASSIGNMENT_CREATE
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  payoutCompleteMarkAdmin: function (
    succes_cb,
    failed_cb,
    progress_cb,
    params
  ) {
    // Screen progress set to true
    progress_cb(true);

    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false

        // Return sucess response
        return succes_cb(false, response);
      },

      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_PAYOUTS_MARK_COMPLETED
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  postAddInfluencers: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_ADD_INFLUENCER),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  /** Alias for postAddInfluencers; supports batch body (identifier_ids array). */
  postAddInfluencer: function (succes_cb, failed_cb, progress_cb, params) {
    return Core.postAddInfluencers(succes_cb, failed_cb, progress_cb, params);
  },
  getBatchSyncStatus: function (succes_cb, failed_cb, progress_cb, params) {
    if (typeof progress_cb === "function") {
      progress_cb(true);
    }
    HttpBrowserRequest.fetch(
      function (error, response) {
        if (typeof progress_cb === "function") {
          progress_cb(false);
        }
        if (error) {
          return failed_cb(error);
        }
        if (response && response.success) {
          return succes_cb(response);
        }
        return failed_cb(response?.err_l || response || "Failed to get batch sync status");
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_BATCH_SYNC_STATUS),
      Config.GET_METHOD,
      params,
      "json"
    );
  },
  postMarkFreeCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_MARK_CAMPAIGN_FREE
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  postCollectionUpdate: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_COLLECTION_UPDATE
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  postBanOrg: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_BAN_ORG
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  extendDataCampaign: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_EXTEND_CAMPAIGN
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  sendEmail: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_EMAIL
      ),
      Config.GET_METHOD,
      params,
      "json"
    );
  },
  priceList: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_PRICE_REQUEST_LIST
      ),
      Config.GET_METHOD,
      params,
      "json"
    );
  },
  sendPrice: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_PRICE_SEND_PRICE
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  bidDetails: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_GET_BID_DETAILS
      ),
      Config.GET_METHOD,
      params,
      "json"
    );
  },
  acceptOffer: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_ACCEPT_BID
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  rejectOffer: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_REJECT_BID
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  rejectPriceRequest: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_POST_REJECT_INVITE
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  startAssignment: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_START_ASSIGNMENT
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  submitContent: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SUBMIT_CONTENT
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  submitContentUrl: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return success response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SUBMIT_CONTENT_URL
      ),
      Config.POST_METHOD,
      params,
      "json"
    );
  },
  uploadToS3: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        // Incase of error
        if (response && !response.success) {
          progress_cb(false); // Screen progress set to false
          return failed_cb(response.err_l);
        }
        console.log("trans", response);
        progress_cb(false); // Screen progress set to false
        // Return sucess response
        return succes_cb(false, response);
      },
      _api_function.constructUrn(
        Config.API_ENDPOINTS.API_URN_SUBMIT_CONTENT_TO_S3
      ),
      Config.GET_METHOD,
      params,
      "json"
    );
  },

  updateMetaData: function (succes_cb, failed_cb, progress_cb, params) {
  console.log("Config.API_ENDPOINTS",Config)
  progress_cb(true);
  
  HttpBrowserRequest.fetch(
    function (error, response, status) {
      progress_cb(false);

      if (error || status !== 200) {
        return failed_cb(error);
      }

      // ✅ response is a Blob (PDF)
      succes_cb(response);
    },
    _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_UPDATE_METADATA),
    Config.POST_METHOD,
    params,
    "json"
  );
},  
  verifyKycAuto: function (succes_cb, failed_cb, progress_cb, params) {
  console.log("Config.API_ENDPOINTS",Config)
  progress_cb(true);
  
  HttpBrowserRequest.fetch(
    function (error, response, status) {
      progress_cb(false);

      if (error || status !== 200) {
        return failed_cb(error);
      }

      // ✅ response is a Blob (PDF)
      succes_cb(response);
    },
    _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_VERIFY_KYC_AUTO),
    Config.POST_METHOD,
    params,
    "json"
  );
},  
  getBrandList: function (succes_cb, failed_cb, progress_cb, params) {
  console.log("Config.API_ENDPOINTS",Config)
  progress_cb(true);
  
  HttpBrowserRequest.fetch(
    function (error, response, status) {
      progress_cb(false);

      if (error || status !== 200) {
        return failed_cb(error);
      }

      // ✅ response is a Blob (PDF)
      succes_cb(response);
    },
    _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_GET_BRAND_LIST_ALL),
    Config.POST_METHOD,
    params,
    "json"
  );
},  
  rejectPayout: function (succes_cb, failed_cb, progress_cb, params) {
    // Screen progress set to true
    progress_cb(true);
    
    // http Request
    HttpBrowserRequest.fetch(
      function (error, response) {
        // Callback function
        progress_cb(false); // Screen progress set to false
        
        // Incase of error
        if (error) {
          return failed_cb("Something went wrong");
        }
        
        if (response && !response.success) {
          return failed_cb(response.err_l);
        }
        
        // Return success response
        return succes_cb(response);
      },
      _api_function.constructUrn(Config.API_ENDPOINTS.API_URN_REJECT_PAYOUT),
      Config.POST_METHOD,
      params,
      "json"
    );
  },  


};

export default Core;

//////////////////////////// Public Functions END //////////////////////////////

/////////////////////////// Private Functions START ////////////////////////////
const _api_function = {
  constructUrn: function (end_point) {
    return Config.BASE_URL + end_point;
  },
};

//////////////////////////// Private Functions END /////////////////////////////
